import { render, staticRenderFns } from "./ModalPdfView.vue?vue&type=template&id=6866765e&"
import script from "./ModalPdfView.vue?vue&type=script&lang=js&"
export * from "./ModalPdfView.vue?vue&type=script&lang=js&"
import style0 from "./ModalPdfView.vue?vue&type=style&index=0&id=6866765e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports